import React from 'react'
import { ReportHeading } from '../common/ReportHeading'
import { Box, } from '@mui/material'
import { Item } from '../../../common/snippets'
import { useState } from 'react'
import RefundReport from './refundReport/RefundReport'
import { connect } from 'react-redux'
import { updateOwnBooingFitlerData } from '../../../../store/reports/reports_action'
import useToken from '../../../helpers/useTokens'

const Index = (props) => {
  const {
    data: { common },
    updateOwnBooingFitlerData,
  } = props
  const [selectedTab, setSelectedTab] = useState(0)
  const reportName = 'Refund'
  let { loginData = {} } = useToken()
  let isFromUrl = false
  if (!loginData) {
    isFromUrl = true
  }

  return (
    <Item sx={{ padding: '0' }} className="reports">
      <Box className="reports">
        {!isFromUrl && <ReportHeading reportName={reportName} />}
      </Box>

      <Box>
        {(selectedTab === 0 && <RefundReport />)
        }
      </Box>
    </Item>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { updateOwnBooingFitlerData }
export default connect(mapStateToProps, mapDispatchToProps)(Index)
